module.exports = __webpack_public_path__ + "static/media/Portal.3dfd693f.jpg";